import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form'
import { Flex, Heading, FormErrorMessage,  FormLabel,  FormControl,  Input,  Button, Box, Stack, SimpleGrid, Select } from '@chakra-ui/react';
import Fields from '../Fields';

type Props = {
  item: any;
  list: any[];
  index: number;
  onUpdateFieldGroupItem: (item:any, index:number) => void;
};

function FieldGroupItem({ item, list, index, onUpdateFieldGroupItem }: Props) {
  const [itemLocal, setItemLocal] = useState(item);

  const {
    handleSubmit,
    register,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: itemLocal
  });

  function onSubmit(values:any) {
    setItemLocal({
      ...itemLocal,
      ...values
    })
  }

  const onFieldsUpdate = (fields:any[]) => {		
    setItemLocal({
      ...itemLocal,
      fields: fields
    })
  }

  useEffect(() => {
    onUpdateFieldGroupItem(itemLocal, index);
  }, [itemLocal])

  return (
    <>
      <Box border="1px" borderColor="b.lg" p="4">
        <Heading size="sm" pb="3" color="b.gr">그룹 정보</Heading>
        <Box pb="6">
          <form name="newFieldGroup" onSubmit={handleSubmit(onSubmit)}>
            <SimpleGrid columns={[4]} spacing='10px' >
              <FormControl>
                <Input
                  size="sm"
                  id='id'
                  placeholder='그룹 id(영문자, 숫자, _ 만 가능)'
                  {...register('id', { required: true })}
                />
              </FormControl>
              <FormControl>
                <Input
                  size="sm"
                  id='title'
                  placeholder='그룹 제목'
                  {...register('title', { required: true })}
                />
              </FormControl>
              <FormControl>
                <Select size="sm" placeholder='그룹 정렬' {...register('layout', { required: true })}>
                  <option value="vertical">세로</option>
                  <option value="horizontal">가로</option>
                </Select>
              </FormControl>
              <Button variant='outline' size="sm" colorScheme="g" isLoading={isSubmitting} type='submit'>
                그룹 정보 적용
              </Button>
            </SimpleGrid>
          </form>
        </Box>

        <Fields list={item.fields} onFieldsUpdate={onFieldsUpdate} />
      </Box>
    </>
  );
}

FieldGroupItem.defaultProps = {
};

export default FieldGroupItem;
